import { Box, Text } from '@chakra-ui/react';
import { useContext } from 'react';
import InvoicesToPayContext from '../contexts/InvoicesToPayContext';
import { getAmountToPay } from '../helpers/amountToPay';
import InvoiceDataContext from '../contexts/InvoiceDataContext';
import SubscriptionsContext from '../contexts/SubscriptionsContext';
import LineItemGroup from './LineItemGroup';
import PaymentMethodElement from './PaymentMethodElement';
import PaymentSummaryTotalAmount from './PaymentSummaryTotalAmount';
import PalommaPlusBreakdownRow from './PalommaPlusBreakdownRow';
import StepperContext from '../contexts/StepperContext';
import { calculatePaymentTotals } from '../helpers/credits';
import { invoiceReference } from '../types';

const PaymentSummary = (): JSX.Element => {
  const invoicesToPayCtx = useContext(InvoicesToPayContext);
  const { subscriptionToCharge, totalSubscriptionAmount } = useContext(SubscriptionsContext);
  const { cardFeePercentage, creditsBalance, useCredits } = useContext(InvoiceDataContext);
  const { paymentMethodContext } = useContext(StepperContext);
  const { paymentMethod } = paymentMethodContext;

  const isCard = paymentMethod?.id === 'card';
  const { creditsApplied, cardFee } = calculatePaymentTotals({
    invoiceTotal: invoicesToPayCtx.totalAmountToPay,
    subscriptionTotal: totalSubscriptionAmount,
    creditsBalance,
    useCredits,
    cardFeePercentage: cardFeePercentage ?? 0,
    isCard,
  });

  return (
    <Box display={'flex'} flexDirection={'column'} gap={0} width={'100%'}>
      <Box py={4} borderBottom={'1px solid'} borderColor={'#DFDEE2'}>
        <Text fontWeight={600}>Detalle de pago</Text>
      </Box>

      <Box display={'flex'} flexDirection={'column'} gap={4} pt={4}>
        <LineItemGroup
          label="Facturas"
          amount={invoicesToPayCtx.totalAmountToPay}
          items={invoicesToPayCtx.invoicesToPay.map((ele) => ({
            label: invoiceReference(ele),
            amount: getAmountToPay(ele),
          }))}
        />

        {subscriptionToCharge && <PalommaPlusBreakdownRow />}

        {useCredits && creditsApplied > 0 && <LineItemGroup label="Saldo Palomma" amount={-creditsApplied} />}

        {isCard && cardFeePercentage && (
          <LineItemGroup label={`+${cardFeePercentage}% tarjeta de crédito`} amount={cardFee} />
        )}
      </Box>

      {paymentMethod && (
        <Box pt={4}>
          <PaymentMethodElement />
        </Box>
      )}
      <PaymentSummaryTotalAmount />
    </Box>
  );
};

export default PaymentSummary;
